import styled from 'styled-components';

import {AdminListingPageContainer} from '../../../../../elements-new';

export const BasicInfoContainer = styled(AdminListingPageContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
